// @ts-ignore
export const addPrevStateandChangedStatus = (filterState, isApply) => {
    let newFilterState = {};
    const metrics = Object.keys(filterState).filter((_metric) => {
        return !['filterCount'].includes(_metric);
    });

    metrics.map((_metric) => {
        if (_metric === 'customFilter') {
            // @ts-ignore
            newFilterState[_metric] = filterState[_metric]?.map((_additionalFilter) => {
                return {
                    ..._additionalFilter,
                    hasChanged: false,
                    prevState: {
                        value: _additionalFilter?.value,
                        metric: _additionalFilter?.metric,
                        operator: _additionalFilter?.operator,
                        dataType: _additionalFilter?.dataType,
                        compare: _additionalFilter?.compare,
                    },
                };
            });
        } else if (_metric === 'sortKey') {
            // @ts-ignore
            newFilterState[_metric] = {
                ...filterState[_metric],
                hasChanged: isApply
                    ? false
                    : !(
                          filterState[_metric]?.name === filterState[_metric]?.prevState?.name &&
                          filterState[_metric]?.lag === filterState[_metric]?.prevState?.lag &&
                          filterState[_metric]?.key === filterState[_metric]?.prevState?.key
                      ),
                prevState: {
                    name: filterState[_metric]?.name,
                    lag: filterState[_metric]?.lag,
                    key: filterState[_metric]?.key,
                    value: filterState[_metric]?.value,
                },
            };
        } else {
            // @ts-ignore
            newFilterState[_metric] = {
                ...filterState[_metric],
                hasChanged: isApply
                    ? false
                    : !(
                          filterState[_metric]?.min === filterState[_metric]?.prevState?.min &&
                          filterState[_metric]?.max === filterState[_metric]?.prevState?.max
                      ),
                prevState: {
                    min: filterState[_metric]?.currentMin,
                    max: filterState[_metric]?.currentMax,
                },
            };
        }
    });
    return {
        ...filterState,
        ...newFilterState,
    };
};

// @ts-ignore
export const restoreEditedFilterstoLastCheckPoint = (filterState, editedFilters, editedCustomFilters, initialState) => {
    let newFilterState = {};
    let filtersInOriginalState = 0;

    const metrics = Object.keys(filterState).filter((_metric) => {
        return !['filterCount'].includes(_metric);
    });

    metrics.map((_metric) => {
        if (editedFilters.includes(_metric)) {
            if (_metric === 'customFilter') {
                // @ts-ignore
                newFilterState[_metric] = filterState[_metric]
                    // @ts-ignore
                    ?.filter((_additionalFilter) => {
                        const isCustomFilterEdited = editedCustomFilters.includes(_additionalFilter?.name);
                        const isExistingCustomFilter = _additionalFilter?.prevState;

                        (!isCustomFilterEdited || !isExistingCustomFilter) && filtersInOriginalState++;
                        return isCustomFilterEdited && isExistingCustomFilter;
                    })
                    // @ts-ignore
                    .map((_additionalFilter) => {
                        return {
                            ..._additionalFilter,
                            hasChanged: false,
                            value: _additionalFilter?.prevState?.value,
                            metric: _additionalFilter?.prevState?.metric,
                            operator: _additionalFilter?.prevState?.operator,
                            dataType: _additionalFilter?.prevState?.dataType,
                            compare: _additionalFilter?.prevState?.compare,
                            prevState: {},
                        };
                    });
            } else if (_metric === 'sortKey') {
                // @ts-ignore
                newFilterState[_metric] = {
                    ...filterState[_metric],
                    hasChanged: false,
                    name: filterState[_metric]?.prevState?.name,
                    lag: filterState[_metric]?.prevState?.lag,
                    key: filterState[_metric]?.prevState?.key,
                    value: filterState[_metric]?.prevState?.value,
                };
            } else {
                let isEdited = true;
                if (
                    filterState[_metric]?.prevState?.min === initialState[_metric]?.min &&
                    filterState[_metric]?.prevState?.max === initialState[_metric]?.max
                ) {
                    filtersInOriginalState++;
                    isEdited = false;
                }

                // @ts-ignore
                newFilterState[_metric] = {
                    ...filterState[_metric],
                    hasChanged: false,
                    min: filterState[_metric]?.prevState?.min,
                    max: filterState[_metric]?.prevState?.max,
                    filtered: isEdited,
                    show: isEdited,
                    edit: isEdited,
                };
            }
        }
    });
    return {
        ...filterState,
        filterCount:
            // @ts-ignore
            filterState['filterCount'] - filtersInOriginalState,
        ...newFilterState,
    };
};

// @ts-ignore
type AddFilterFormState = {
    metric: Record<string, unknown>;
    operator: string;
    value: string;
    isMetric: boolean;
    isTotalLevel?: boolean;
    comparisonMetric: Record<string, unknown>;
    comparisonOperator: string;
    tempValue: string;
};

function flattenMetricOptionLeaves(options: Array<Record<string, unknown>>): Array<Record<string, unknown>> {
    const flattened: Array<Record<string, unknown>> = [];
    const visit = (nodes: Array<Record<string, unknown>>) => {
        nodes.forEach((node) => {
            const children = Array.isArray(node.children) ? node.children : [];
            if (children.length === 0 && (node.metric || node.name)) {
                flattened.push(node);
            }
            if (children.length > 0) {
                visit(children as Array<Record<string, unknown>>);
            }
        });
    };
    visit(options);
    return flattened;
}

function resolveMetricLag(entry: { metric?: string; key?: string; lag?: number | null | undefined }): number {
    if (typeof entry.lag === 'number') {
        return entry.lag;
    }
    const key = entry.key ?? '';
    const metric = entry.metric ?? '';
    if (metric && key.startsWith(`${metric}_`)) {
        const suffix = key.slice(metric.length + 1);
        const parsed = Number(suffix);
        if (!Number.isNaN(parsed) && `${parsed}` === suffix) {
            return parsed;
        }
    }
    return 0;
}

function resolveMetricFromOptions(
    entry: Record<string, unknown>,
    flatMetrics: Array<Record<string, unknown>>,
): Record<string, unknown> | undefined {
    if (entry.key) {
        const byKey = flatMetrics.find(
            (option) => option.key === entry.key || option.value === entry.key,
        );
        if (byKey) return byKey;
    }

    if (entry.name) {
        const byName = flatMetrics.find((option) => option.name === entry.name);
        if (byName) return byName;
    }

    const entryLag = resolveMetricLag(entry as { metric?: string; key?: string; lag?: number | null });
    const entryMetric = entry.metric ?? entry.key;
    if (entryMetric) {
        const metricLagMatches = flatMetrics.filter(
            (option) =>
                option.metric === entryMetric &&
                resolveMetricLag(option as { metric?: string; key?: string; lag?: number | null }) === entryLag,
        );
        if (metricLagMatches.length === 1) {
            return metricLagMatches[0];
        }

        const byMetric = flatMetrics.find((option) => option.metric === entryMetric);
        if (byMetric) return byMetric;
    }

    return undefined;
}

function hasResolvedMetricMetadata(entry: Record<string, unknown>): boolean {
    return Boolean(entry.unit && entry.name && entry.metric);
}

/** Map applied customFilter reducer entries into Add Filter popover form rows. */
export const mapCustomFiltersToAddFilterFormState = (
    customFilters: Array<Record<string, unknown>> | undefined,
    metricOptions?: Array<Record<string, unknown>>,
): AddFilterFormState[] => {
    const flatMetrics = metricOptions?.length ? flattenMetricOptionLeaves(metricOptions) : [];

    return (customFilters ?? []).map((customFilter) => {
        const resolvedMetric = hasResolvedMetricMetadata(customFilter)
            ? customFilter
            : flatMetrics.length
              ? resolveMetricFromOptions(customFilter, flatMetrics) ?? customFilter
              : customFilter;
        const compareRaw =
            customFilter.isMetric &&
            customFilter.compare &&
            typeof customFilter.compare === 'object' &&
            Object.keys(customFilter.compare as object).length
                ? (customFilter.compare as Record<string, unknown>)
                : null;
        const resolvedCompare =
            compareRaw && hasResolvedMetricMetadata(compareRaw)
                ? compareRaw
                : compareRaw && flatMetrics.length
                  ? resolveMetricFromOptions(compareRaw, flatMetrics) ?? compareRaw
                  : compareRaw ?? {};
        const valueStr = customFilter.isMetric
            ? '0'
            : customFilter.value != null && customFilter.value !== ''
              ? String(customFilter.value)
              : '0';

        const row = {
            metric: resolvedMetric,
            operator: (customFilter.operator as string) || '',
            value: valueStr,
            isMetric: Boolean(customFilter.isMetric),
            isTotalLevel: Boolean(customFilter.isTotalLevel),
            comparisonMetric: resolvedCompare,
            comparisonOperator: '',
            tempValue: null as unknown as string,
        };

        return row;
    });
};

// @ts-ignore
export const getEditedFilters = (sortFilterState) => {
    const editedFilters: any[] = [];
    const editedCustomFilters = [];

    const metrics = Object.keys(sortFilterState).filter((_metric) => {
        return !['filterCount'].includes(_metric);
    });
    for (let i = 0; i < metrics?.length; i++) {
        let _metric = metrics[i];
        if (_metric === 'customFilter') {
            const customFilters = sortFilterState[_metric];
            for (let i = 0; i < customFilters?.length; i++) {
                if (customFilters[i]?.hasChanged) {
                    !editedFilters.includes('customFilter') && editedFilters.push('customFilter');
                    editedCustomFilters.push(customFilters[i]?.name);
                }
            }
        } else {
            if (sortFilterState[_metric]?.hasChanged) {
                editedFilters.push(_metric);
            }
        }
    }
    return { editedFilters, editedCustomFilters };
};
